import { HeaderMenuItem } from "@shetharp/gatsby-theme-polaroid";

export const headerMenuItems: HeaderMenuItem[] = [
    {
        label: "Home",
        slug: "/",
    },
    // {
    //     label: "Blog",
    //     slug: "/blog",
    //     isVisibleTablet: false,
    // },
    // {
    //     label: "Tags",
    //     slug: "/tags",
    // },
    {
        label: "About",
        slug: "/about",
    },
    {
        label: "GitHub",
        href: "https://github.com/deepsheth",
    },
    {
        label: "Twitter",
        href: "https://twitter.com/itdeepends",
    },
    {
        label: "Contact",
        href: "https://deepsheth.com/contact",
    },
];
